module.exports = __webpack_public_path__ + "images/12go1351c4810353cce9a45967b9af7e7751.png";